const STORAGE_KEY = "edu_device_id_v1"

export function getDeviceId(): string {
  try {
    let id = localStorage.getItem(STORAGE_KEY)

    if (!id) {
      id = crypto.randomUUID()
      localStorage.setItem(STORAGE_KEY, id)
    }

    return id
  } catch {
    // fallback если localStorage недоступен
    return crypto.randomUUID()
  }
}